import { Link } from 'gatsby';
import * as React from 'react';
import styled, { css } from 'styled-components';

const StyledUL = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style-type: none;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 0;
`;

const StyledLink = styled(Link)`
  padding: 12px;
  transition: all 0.2s ease;
  color: ${props =>
    props.disabled ? props.theme.colors.copyDimmed : props.theme.colors.copy};

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      text-decoration: none;
    `}

  ${props =>
    props.iscurrent === 1
      ? css`
          background: ${(props = props.theme.colors.complimentaryPurple)};
          cursor: default;
          border-radius: 4px;
        `
      : css`
          &:hover {
            background: ${(props = props.theme.colors.complimentaryPurple)};
            opacity: 0.8;
            border-radius: 4px;
          }
        `}
`;

export const Pagination = ({ numPages, currentPage }) => {
  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  const prevPage = currentPage - 1 === 1 ? '/' : (currentPage - 1).toString();
  const nextPage = (currentPage + 1).toString();

  if (numPages === 1) {
    return null;
  }

  return (
    <StyledUL>
      <li>
        <StyledLink
          disabled={isFirst}
          to={`/${prevPage === '/' ? '' : prevPage}`}
          rel="prev"
          tabIndex={isFirst ? -1 : 0}
        >
          Previous
        </StyledLink>
      </li>

      {Array.from({ length: numPages }, (_, i) => (
        <li key={`pagination-number${i + 1}`}>
          <StyledLink
            to={`/${i === 0 ? '' : i + 1}`}
            iscurrent={i + 1 === currentPage ? 1 : 0}
            tabIndex={i + 1 === currentPage ? -1 : 0}
          >
            {i + 1}
          </StyledLink>
        </li>
      ))}

      <li>
        <StyledLink
          disabled={isLast}
          to={`/${nextPage}`}
          rel="next"
          tabIndex={isLast ? -1 : 0}
        >
          Next
        </StyledLink>
      </li>
    </StyledUL>
  );
};
